<template>
  <div>
    <div class="container-fluid p-5">
        <center>
            <h4 class="card-title text-dark">{{getMessage.username}}</h4>
            <img style="height: 75px; width: 75px; display: block; border-radius:100px; border:1.5px solid #000000;" class="mb-4" :src="'/images/'+ getMessage.imgURL + '.svg'" :alt="getMessage.username">
            <h6 class="card-subtitle mb-2 text-muted" style="margin-top:-12px; font-size:10pt;">{{getMessage.date}}</h6>
            <p class="card-text text-dark mt-3">"{{getMessage.message}}"</p>
        </center>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import MyModal from '../components/myModal';
export default {
  data: () => ({
      getMessage: '',
  }),
  components:{
    MyModal,
  },
  mounted() {
    var urlGetWords = 'https://young-brook-59453.herokuapp.com/specific-words/'+this.$route.params.numberWord;
    console.log(urlGetWords);
    fetch(urlGetWords).then(res => res.json()).then((result) => {
        this.getMessage = result;
    });
  },
};
</script>